import { Typography, List, Paper, Divider, Stack } from '@mui/material';

import { PickTeamPlayer, Player, Position, Team } from '../types';
import { DragAndDropWithoutContext } from './DragAndDrop';
import GroupPlayerItem from './GroupPlayerItem';

type PlayerGroupCardProps = {
  appearances: number;
  index: number;
  players: PickTeamPlayer[];
  onSetPlayerPosition?: (player: Player, position?: Position) => void;
  onDragPlayerEnd?: (fromIndex: number, toIndex: number, team: Team) => void;
  isDisabled?: boolean;
  isActive?: boolean;
  showStats?: boolean;
};

function getDroppableStyle(isDroppingOver: boolean) {
  return {
    height: '100%',
    background: isDroppingOver ? '#81c784' : 'inherit',
  };
}

export default function PlayerGroupCard({
  appearances,
  index,
  players,
  isDisabled,
  isActive,
  showStats,
}: Readonly<PlayerGroupCardProps>) {
  if (players.length === 0 || !isActive) {
    return null;
  }

  return (
    <Paper
      elevation={4}
      sx={{
        padding: 2,
        display: 'flex',
        flexDirection: 'column',
        mb: {
          xs: 3,
          sm: 3,
          md: 3,
          lg: 0,
          xl: 0,
        },
        minWidth: {
          lg: '320px',
        },
      }}
      variant={isDisabled ? 'outlined' : 'elevation'}
    >
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography
          variant="button"
          sx={{ fontSize: 18, textTransform: 'none' }}
        >
          Appearances: {appearances}
        </Typography>
      </Stack>
      <Divider sx={{ mt: 1 }} />
      <List
        style={{ marginLeft: '-16px', marginRight: '-16px', height: '100%' }}
      >
        <DragAndDropWithoutContext<PickTeamPlayer>
          droppableId={`${appearances}:${index}`}
          draggableItems={players}
          getDraggableId={(player) => player.name}
          getDroppableStyle={getDroppableStyle}
          isDragDisabled={isDisabled}
          itemRenderer={(item, isDragging, dragHandleProps) => (
            <GroupPlayerItem
              player={item}
              dragHandleProps={dragHandleProps}
              isDragging={isDragging}
              showAppearances={false}
              showStats={showStats}
            />
          )}
        />
      </List>
    </Paper>
  );
}
